<div
  (click)="toggleSublocations()"
  [ngClass]="{ 'cursor-pointer': $safeNavigationMigration(sublocations()?.length) > 0 }"
  class="flex items-center justify-between gap-2 rounded-lg p-1 hover:bg-proffeo-surface-muted"
>
  <div class="flex items-center">
    @if (!isReadonly()) {
      <mat-radio-button
        (change)="selectLocation(location())"
        (click)="$event.stopPropagation()"
        [checked]="location().id === selectedLocation()?.id"
        [value]="location().id"
        class="mr-2 shrink-0"
      />
      <span [ngClass]="{ 'font-semibold': isPartOfSelectedLocation(location()) }">{{ location().name }}</span>
    } @else {
      @if (location().id === selectedLocation()?.id) {
        <mat-icon
          fontIcon="task_alt"
          class="text-proffeo-accent-500 mr-1 icon-md"
        />
      }

      <span [ngClass]="{ 'font-semibold': isPartOfSelectedLocation(location()) }">{{ location().name }}</span>
    }
  </div>
  <span class="flex items-center">
    <div class="artbygg-col-xs">
      <!-- @if (attachments$ | async; as attachments) {
        @if (attachments.length > 0) {
          <div
            (click)="toggleAttachments()" class="flex w-[38px] cursor-pointer items-center justify-start rounded border border-proffeo-surface-off p-1"
          >
            <mat-icon
    fontIcon="attach_file"
    [ngClass]="{'icon-muted': !attachmentsVisible, 'icon-danger': attachmentsVisible}"
    class="icon-md icon-muted"
  />
          <span
            [ngClass]="{ 'text-proffeo-muted': !attachmentsVisible, 'text-proffeo-danger': attachmentsVisible }" class="text-sm leading-none"
          >{{ attachments.length }}
          </span>
        </div>
        }
      } -->
    </div>
    <div class="artbygg-col-xs">
      @if (sublocations()?.length > 0) {
        <button
          [attr.aria-expanded]="sublocationsVisible"
          [class.proffeo-ui-tree-count-chip-active]="sublocationsVisible"
          type="button"
          class="proffeo-ui-tree-count-chip"
        >
          <mat-icon
            fontIcon="subdirectory_arrow_right"
            class="icon-sm opacity-50"
          />
          <span>{{ sublocations().length }}</span>
        </button>
      }
    </div>
  </span>
</div>

@if (attachmentsVisible) {
  <div class="ml-[1rem] mt-4">
    <!--  XXXXXXXXXXXXXX        <proffeo-carousel [images]="attachments$ | async" (deleteFile)="onDeleteLocationFile($event)"></aartbygg-carousel>-->

    <div class="flex items-center gap-2">
      <!--      <proffeo-thumbnails-carousel-->
      <!-- TODO: repair-->
      <!--      <artbygg-thumbnails-carousel-->
      <!--        (photoDeleted)="onDeleteLocationFile($event)"-->
      <!--        [images]="attachments$ | async"-->
      <!-- class="overflow-hidden"-->
      <!--      ></proffeo-thumbnails-carousel>-->

      <div class="flex w-full overflow-x-auto">
        <div class="flex gap-2 whitespace-nowrap">
          @for (file of attachments(); let i = $index; track i) {
            <div class="relative flex-none">
              @if (file.isImage()) {
                <img
                  (click)="openDialog(i)"
                  [src]="file.previewUrl()"
                  alt="image"
                  class="border-proffeo-accent h-24 w-24 cursor-pointer rounded-md border-2 object-cover"
                />
                <!-- TODO: repair-->
                <!--                <img-->
                <!--                  [ngClass]="{ 'rounded-md border-2 border-primary': isActive(i) }"-->
                <!-- class="cursor-pointer object-cover h-24 w-24"-->
                <!--                  [src]="file.previewUrl()"-->
                <!--                  alt="image"-->
                <!--                />-->
              } @else {
                <div
                  (click)="openDialog(i)"
                  class="border-proffeo-accent flex h-24 w-24 cursor-pointer flex-col items-center justify-center rounded-md border-2"
                >
                  <!-- TODO: repair-->
                  <!--                  <div-->
                  <!--                    [ngClass]="isActive(i) ? 'rounded-md border-2 border-primary' : 'border-proffeo-border'"-->
                  <!-- class="cursor-pointer flex flex-col items-center justify-center h-24 w-24 border"-->
                  <!--                  >-->
                  @if (file.isPdf()) {
                    <mat-icon
                      fontIcon="description"
                      class="text-proffeo-accent text-4xl"
                    />
                  }

                  @if (file.isVideo()) {
                    <mat-icon
                      fontIcon="movie"
                      class="text-proffeo-action-primary text-4xl"
                    />
                  }
                  <div class="mt-2 w-24 truncate px-2 text-center text-sm text-proffeo-muted">
                    {{ file.name }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (sublocationsVisible) {
  <div class="ml-[1rem]">
    @for (location of sublocations(); track location.id) {
      <proffeo-single-location-item
        (locationSelected)="selectLocation($event)"
        [location]="location"
        [isReadonly]="isReadonly()"
        [projectId]="projectId"
        [selectedLocation]="selectedLocation()"
      ></proffeo-single-location-item>
    }
  </div>
}
